<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'StealStrickStat',
  props: {
    chartTitle: {
      type: String,
      default: '转动次数'
    },
    title: {
      type: String,
      default: '转动次数'
    },
    color: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#1E90FF', '#FF69B4', '#FF7F50', '#BA55D3'],
        title: {
          text: ''
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45 // 标签旋转45度
          }
        },
        legend: {
          data: ['转动次数', '人均转动次数'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          name: '总计',
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        {
          name: '人均',
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [{
          name: '',
          data: [],
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        },
        {
          name: '',
          data: [],
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          yAxisIndex: 1,
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }]
      }
    },
    refresh(data) {
      const date = []
      const seriesData = []
      const seriesAvgData = []
      for (const i in data) {
        date.push(dateStrTodate(data[i].date))
        seriesData.push(data[i].count)
        seriesAvgData.push(data[i].count_avg)
      }
      this.option.title.text = this.chartTitle
      this.option.xAxis.data = date
      this.option.series[0].name = this.title
      this.option.series[0].data = seriesData
      this.option.series[1].name = '人均转动次数'
      this.option.series[1].data = seriesAvgData
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
